import { render, staticRenderFns } from "./BadgeboxNoConsent.vue?vue&type=template&id=0f83c006&"
import script from "./BadgeboxNoConsent.vue?vue&type=script&lang=js&"
export * from "./BadgeboxNoConsent.vue?vue&type=script&lang=js&"
import style0 from "./BadgeboxNoConsent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports